import $ from 'jquery';
import { algoliasearch } from "algoliasearch";
import instantsearch from 'instantsearch.js';
import { connectInfiniteHits, connectRange } from 'instantsearch.js/es/connectors';
import infiniteHits from '../components/infiniteHits';
import {lockBody, unlockBody} from '../utils.js';
import {
  menu,
  configure,
  hierarchicalMenu,
  clearRefinements,
  refinementList,
  rangeSlider,
  toggleRefinement,
} from 'instantsearch.js/es/widgets';
import { history } from 'instantsearch.js/es/lib/routers';
import {
  connectSearchBox,
  connectCurrentRefinements,
} from 'instantsearch.js/es/connectors';
import { connectHits } from 'instantsearch.js/es/connectors';
import {
  algoliaAppId,
  algoliaApiKey,
  boatSearchIndex,
} from '../variables';
import { boatHit, noResult, boatsButton } from '../templates';
import { dynamicUriTemplate, extractParamsFromUri } from '../functions';

// eslint-disable-next-line no-undef
const { __, _n, sprintf } = wp.i18n;

// eslint-disable-next-line no-undef
const object = vnObject;

const {
  boatBrandMainSlug,
  query,
  category,
} = object.algoliaQueryStrings;

const slugs = {
  query,
  category,
};

let boatBrandSearch;
const checkEl = document.querySelector('.pt-boat-brand__hits');
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey);
  var brandId = $('.js-boat-brand-id').val();  // `brandId` taken from an input field

  boatBrandSearch = instantsearch({
    indexName: boatSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      router: history({
        cleanUrlOnDispose: false,
        createURL({ location, routeState }) {},
        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs);
          return {
            query: params[slugs.query] && params[slugs.query][0],
            category: params[slugs.category],
            // Add brandId to the URL state if available
            brandId: params['brandId'],
          };
        },
      }),
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[boatSearchIndex] || {};

          const res = {
            query: indexUiState.query,
            category: indexUiState.hierarchicalMenu?.['category.lvl0'],
            // Include the `brandId` in the route state
            brandId: indexUiState.brandId,
          };

          return res;
        },
        routeToState(routeState) {
          return {
            [boatSearchIndex]: {
              query: routeState.query,
              location_filter: routeState.location_filter,
              hierarchicalMenu: {
                'category.lvl0': routeState.category,
              },
              // Ensure brandId is included in the state for refinement
              brandId: routeState.brandId,
            },
          };
        },
      },
    },
  });

  const boatItem = ({ hits, sendEvent, widgetParams }) => {
    const container = document.querySelector(widgetParams.container);
    container.innerHTML = `
      ${
        hits.length
            ? hits.map((item) => {
              return boatHit(item, 'g-col-12 g-col-md-6 g-col-lg-4');
            }).join('')
            : noResult
    }
    `;
    container.querySelectorAll('.feed-boat__wrapper').forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Boat Clicked');
      });
    });
  };

  const boatItems = connectHits(boatItem);

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;
    const container = document.querySelector(widgetParams.container);

    if (isFirstRender) {
      const input = document.createElement('input');
      input.type = 'search';
      input.placeholder = widgetParams.placeholder;

      container.insertAdjacentHTML('beforeend', object.loader);

      const reset = document.createElement('button');
      reset.type = 'reset';
      reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>');

      const submit = document.createElement('button');
      submit.type = 'submit';
      submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>');

      input.addEventListener('input', (boat) => {
        refine(boat.target.value);
      });

      reset.addEventListener('click', () => {
        clear();
        // Reset brandId facet
        refine(brandId);  // Make sure the `brandId` is set even if filters are reset
      });

      container.appendChild(input);
      container.appendChild(reset);
      container.appendChild(submit);
    }

    container.querySelector('input').value = query;
    container.querySelector('.vn-loader').hidden = !isSearchStalled;
    container.querySelector('button[type="reset"]').hidden = isSearchStalled || !query;
    container.querySelector('button[type="submit"]').hidden = isSearchStalled;
  };

  const customSearchBox = connectSearchBox(renderSearchBox);
  const customInfiniteHits = connectInfiniteHits(infiniteHits(boatHit, boatsButton));

  const renderCurrentRefinements = ({ items, widgetParams }) => {
    const container = document.querySelector(widgetParams.container);
    const totalItemCount = items.reduce(
        (acc, curr) => acc + curr.refinements.length,
        0
    );

    container.innerHTML = sprintf(
        _n('%s active filter', '%s active filters', totalItemCount, 'vn'),
        totalItemCount
    );
  };

  const customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements);

  boatBrandSearch.addWidgets([
    customSearchBox({
      container: '.pt-boat-brand__search-handler',
      placeholder: __('Search a boat', 'vn'),
      showLoadingIndicator: false,
    }),

    clearRefinements({
      container: '.pt-boat-brand__reset-handler',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<div class="vn-btn vn-btn--primary">
            ${hasRefinements
              ? __('Reset filters', 'vn')
              : __('No filters', 'vn')}
          </div>`;
        },
      },
    }),

    refinementList({
      container: '.pt-boat-brand__boat-condition-handler',
      attribute: 'boatCondition.name',
      limit: 99,
      sortBy: ['name:asc'],
    }),

    refinementList({
      container: '.pt-boat-brand__boat-type-handler',
      attribute: 'boatType.name',
      limit: 99,
      sortBy: ['name:asc'],
    }),

    rangeSlider({
      container: '.pt-boat-brand__passenger-handler',
      attribute: 'passengersCapacity',
    }),

    rangeSlider({
      container: '.pt-boat-brand__power-handler',
      attribute: 'maxPowerHp',
    }),

    customInfiniteHits({
      container: document.querySelector('.pt-boat-brand__hits'),
    }),

    configure({
      hitsPerPage: 21,
      // Add a facet for `boatBrandIds.objectID` to ensure it's always considered
      facets: ['boatBrandIds.objectID'],
      filters: `boatBrandIds.objectID:${brandId}`,
    }),
  ]);

  boatBrandSearch.start();
}

export { boatBrandSearch };

$('.js-open-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeIn();
  lockBody();
});

$('.js-close-algolia-filters').on('click', function (e) {
  $('.js-algolia-filters').fadeOut();
  unlockBody();
});
